
import Icon from '@ant-design/icons';
import * as React from 'react';

const SuccessIconSvg = (props) => {
    return (
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M0 6C0 2.68594 2.68594 0 6 0C9.31406 0 12 2.68594 12 6C12 9.31406 9.31406 12 6 12C2.68594 12 0 9.31406 0 6ZM4.8375 8.40352L9.05039 4.17656C9.21445 4.0125 9.21445 3.74531 9.04922 3.58008C8.88398 3.41602 8.6168 3.41602 8.45273 3.58125L4.61484 7.43086L3.61406 5.67891C3.49922 5.47617 3.24141 5.40586 3.03867 5.52188C2.83594 5.63672 2.76562 5.89453 2.88164 6.09727L4.15781 8.32852C4.23516 8.46562 4.37813 8.5418 4.52461 8.5418C4.59492 8.5418 4.66758 8.52422 4.7332 8.48672C4.7707 8.46562 4.80469 8.43867 4.83281 8.4082L4.8375 8.40352Z" fill="#24A148" />
        </svg>
    );
};

export const SuccessIcon = props => (
    <Icon component={SuccessIconSvg} {...props} />
);
